<template>
  <button
    :class="{'controls-share': true, dark: isDark, [size]: size, disabled: isDisabled, open: shareOpen}"
    :disabled="isDisabled"
    @click="toggleShare"
  ><span class="menu-text">Share</span></button>
</template>

<script>

export default {
  props: {
    store: {
      type: Object,
      default: function () {}
    }
  },
  computed: {
    epi () { return this.store.state.episode },
    isDark () { return this.store.state.isDark },
    size () { return this.store.state.size },
    isDisabled () {
      return !this.epi ||
        !this.epi.id ||
        this.epi.is_hidden
    },
    shareOpen () {
      return this.store.state.showShare
    }
  },
  methods: {
    toggleShare () {
      this.store.setShowShare(!this.store.state.showShare)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'node_modules/simplecast-styles/src/assets/styles/_core/colors.scss';
@import 'node_modules/simplecast-styles/src/assets/styles/_core/fonts.scss';
@import '../assets/styles/breakpoints.scss';

.controls-share {
  background: none;
  border: none;
  color: $black-800;
  cursor: pointer;
  flex: 1;
  margin: 0;
  padding: 0;
  text-align: right;
  text-transform: uppercase;
  white-space: nowrap;
  letter-spacing: .5;
  @include font-xxs(500);
  font-size: 9px;
  height: 9px;

  @media (min-width: $bp_xs) {
    display: inline-block;
    text-align: center;
    @include font-xs(500);
    height: 12px;
  }
  svg {
    display: none;
    fill: $black-800;
    .dark & {
      fill: $white-000;
    }
  }
  .simplecast-player & {
    .menu-icon {
      display: none;
    }
  }
  &.size-mini {
    align-items: center;
    border-radius: 4px;
    border: solid 1px $black-800;
    color: $black-800;
    display: flex;
    justify-content: center;
    margin-left: 0;
    opacity: .95;
    transition: opacity .2s;
    width: 36px;

    &:hover {
      opacity: .6;
    }
    &.dark {
      border: solid 1px $white-000;
    }
    &.open {
      display: none;
    }
    .menu-text {
      display: none;
    }
    .menu-icon {
      display: block;
      width: 16px;
      height: 2px;
      color: $black-800;
      background-color: currentColor;
      position: relative;
      &:after,
      &:before {
        content: '';
        background-color: currentColor;
        width: 16px;
        height: 2px;
        left: 0;
        top: -5px;
        position: absolute;
      }
      &:after {
        top: auto;
        bottom: -5px;
      }
    }
  }
  &.dark {
    color: $white-trans-700;

    @media (min-width: $bp_xs) {
      color: $white-000;
    }
    .menu-icon {
      color: $white-trans-800;
    }
  }
  &.disabled {
    background-color: transparent;
    color: $grey-300;
    cursor: default;
    &.dark {
      color: $grey-700;
    }
  }
}
</style>
